// Runtime configuration utility
// This file provides access to the runtime configuration loaded from config.js

interface RuntimeConfig {
  API_URL: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  ENV: 'development' | 'production';
}

// Default configuration (fallback values)
const defaultConfig: RuntimeConfig = {
  API_URL: process.env.REACT_APP_API_BASE || 'http://localhost:4000/api',
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  ENV: (process.env.NODE_ENV as 'development' | 'production') || 'development'
};

// Get runtime configuration from window object or use default values
export const getConfig = (): RuntimeConfig => {
  if (typeof window !== 'undefined' && window.REACT_APP_CONFIG) {
    return {
      API_URL: window.REACT_APP_CONFIG.API_URL || defaultConfig.API_URL,
      SUPABASE_URL: window.REACT_APP_CONFIG.SUPABASE_URL || defaultConfig.SUPABASE_URL,
      SUPABASE_ANON_KEY: window.REACT_APP_CONFIG.SUPABASE_ANON_KEY || defaultConfig.SUPABASE_ANON_KEY,
      ENV: window.REACT_APP_CONFIG.ENV || defaultConfig.ENV
    };
  }
  return defaultConfig;
};

// Export individual config values for convenience
export const config = getConfig();
export const API_URL = config.API_URL;
export const SUPABASE_URL = config.SUPABASE_URL;
export const SUPABASE_ANON_KEY = config.SUPABASE_ANON_KEY;
export const ENV = config.ENV;

// Helper function to determine if we're in production
export const isProduction = (): boolean => config.ENV === 'production';

// Helper function to determine if we're in development
export const isDevelopment = (): boolean => config.ENV === 'development';
